const RESULT_OPTIONS = ['PASS', 'FAIL'];

function mapReportItem(item, entry) {
  return {
    sourceConditionItemId: item?.id ?? null,
    itemCode: item?.itemCode ?? '',
    itemName: item?.itemName ?? '',
    dataType: item?.dataType ?? '',
    unit: item?.unit ?? null,
    sequence: item?.sequence ?? null,
    required: item?.required !== false,
    criteria: item?.criteria ?? {},
    measuredValue: entry?.measuredValue ?? '',
    result: entry?.result || 'PASS',
    remark: null,
  };
}

/**
 * @param {'first'|'retest'} mode
 * 重測不送物料、Mapping、工單與種類清單。序號不做 trim。
 */
export function buildInspectionReportPayload({
  mode,
  serialNumber,
  mtrId,
  snMappingId,
  workOrderId,
  kind,
  entries,
  overallResult,
  remark,
}) {
  const activeItems = (kind?.items ?? []).filter((item) => item?.status !== 'DEPRECATED');
  const payload = {
    serialNumber: serialNumber ?? '',
    inspectionKindId: kind?.id ?? null,
    conditionRevisionId: kind?.revision?.id ?? null,
    items: activeItems.map((item) => mapReportItem(item, entries?.[item.id])),
    overallResult,
    remark: remark || null,
  };

  if (mode === 'first') {
    payload.mtrId = mtrId || null;
    payload.snMappingId = snMappingId || null;
    if (workOrderId) {
      payload.workOrderId = workOrderId;
    }
    payload.inspectionKinds = [{
      id: kind?.id ?? null,
      code: kind?.code ?? '',
      name: kind?.name ?? '',
      sequence: 1,
    }];
  }

  return payload;
}

export { RESULT_OPTIONS };
